import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";

function ForgotPasswordOne({ props }) {
  const btRef = useRef(null);
  const [loading, setLoading] = useState(false);
  
  function formValidations() {

    if (props.email.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (props.type === "agent" && props.aqdasYes.length < 1) {
      toast.error("Please select your vendor type");
      return false;
    }


    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const isValid = await formValidations();

    if (isValid) {
      if (props.type === "user") {
        const data = {
          email: props.email,
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/users/user-request-password-reset`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );

          const json = await response.json()
          if (response.ok) {
            toast.success("Verification Code Sent");
            props.setIndex(2);
          } else {
            toast.error(json.message);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "agent" || props.type === "tc") {


        const agentVendorType = props.type === "tc"? "Transaction Coordinator": props.aqdasYes

        const data = {
          agentEmail: props.email,
          agentVendorType
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/agents/agent-request-password-reset`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );  
          const json = await response.json()

          if (response.ok) {
            toast.success("Verification Code Sent");
            props.setIndex(2);
          } else {
            toast.error(json.message);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "advertiser") {
        const data = {
          email: props.email,
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/advertiser/advertiser-request-password-reset`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("Verification Code Sent");
            props.setIndex(2);
          } else {
            toast.error(json.message);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "la") {
        const data = {
          email: props.email,
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/auth/lendingAgents/lendingAgents-request-password-reset`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("Verification Code Sent");
            props.setIndex(2);
          } else {
            toast.error(json.message);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  return (
    <>
      <form className="agent-register-form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="form-control agent-register-input-field"
          id="exampleInputEmail1"
          placeholder="Email"
          aria-describedby="emailHelp"
          onChange={(e) => props.setEmail(e.target.value)}
        />
        {
          props.type === "agent"?
          <>
             <p className="schedule-tour-span">Please select your vendor type?</p>
        <div className="schedule-tour-pdf-container">
          <div
            role="button"
            onClick={() => props.setAqdasYes("Showing Agent")}
            className={`make-offer-yes-no-card ${props.aqdasYes === "Showing Agent" ? "make-offer-yes-no-card-active" : ""}`}
          >
            Showing Agent
          </div>
          <div
            role="button"
            onClick={() => props.setAqdasYes("Listing Agent")}
            className={`make-offer-yes-no-card ${props.aqdasYes === "Listing Agent" ? "make-offer-yes-no-card-active" : ""}`}
          >
            Listing Agent
          </div>
        </div>
          </>
          :
          <></>
        }
     
        {loading ? (
          <span className="btn agent-register-button">Sending...</span>
        ) : (
          <button type="submit" className="btn agent-register-button">
            Send Code
          </button>
        )}
      </form>
    </>
  );
}

export default ForgotPasswordOne;
